import { useAtomValue } from 'jotai';
import React from 'react';

import { followupMessageErrorState } from '~/state/layouts/SharedAppShell/atoms';

import { FollowupMessageNotification } from './FollowupMessageErrorNotification';
import { useSubscriptionFollowupMessage } from './use-subscription-followup-message';

export const FollowupMessageNotifications = () => {
  const { notifications } = useAtomValue(followupMessageErrorState);
  const { handleClose } = useSubscriptionFollowupMessage();

  return (
    <>
      {notifications.map((notification) => (
        <FollowupMessageNotification
          key={notification.organizationNotificationId}
          followupMessage={notification.followupMessage}
          notifiedAt={notification.createdAt}
          type={notification.type}
          onClose={handleClose}
        />
      ))}
    </>
  );
};
